import React, { Component, Fragment } from 'react';

/* Components */
import LoadingModal from '../common/loadingModal';
import ExtendedPropertyCreator from '../common/extended_property/extendedPropertyCreator';
import ModalItemCategories from '../common/forms/modalItemCategories';
import SweetAlert from 'react-bootstrap-sweetalert';

class ModalCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showErrors: false,
      categories: {},
      errorsCategories: {}
    };
  }

  handleSubmit = (event) => {
    const showErrors = Object.keys(this.state.errorsCategories).length > 0;
    this.handleShowErrors(showErrors);

    // si hay errores, detiene la ejecucion
    if (showErrors) {
      return;
    }

    // si no hay errores, envia la informacion
    this.props.handleSubmit(event);
  }

  handleShowErrors = (showErrors) => {
    this.setState({
      showErrors
    });
  }

  handleErrorsCategories = (category, error) => {
    let errorsCategories = this.state.errorsCategories;

    if (error) {
      errorsCategories = {...errorsCategories, [category]: error};
    } else {
      delete errorsCategories[category];
    }

    this.setState({
      errorsCategories
    });
  }

  handleChangeCategories = (event) => {
    let tagSelected = [];
    let categories = this.state.categories;
    categories = {...categories, [event.category]: event};

    // compara si se modificaron los tags seleccionados desde el ultimo estado
    const keys = Object.keys(categories);
    keys.map((key) => {
      const category = categories[key];
      tagSelected = [...tagSelected, ...category.tagSelected];
    });

    this.setState({
      categories
    });
  }

  render() {
    return (
      <div
        data-close="ok"
        onClick={this.props.handleModal}
        className={this.props.modal ? `container-modal` : `container-modal hide`}
      >
        <section className="module-title modal-title">
          <h2>{this.props.language.account.createVehicules.creates}</h2>
          {this.props.statusSave == 500 &&
            this.props.dataSave.error.params.map((item, i) => (
              <p key={i} className="error">
                {this.props.language.error[`cod${item.messageCode}`]}{' '}
              </p>
            ))}
          <a>
            <i data-close="ok" onClick={this.props.handleModal} className="fas fa-times-circle" />
          </a>
        </section>
        {this.props.statusSave != 200 && (
          <div className={`box-modal max500`}>
            <section id="modal-create" className="base-form">
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.createVehicules.name}
                    <strong>(*)</strong>
                  </label>
                </div>
                <div>
                  <input autoComplete="off" type="text" id="name" className="modal-input" />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.createVehicules.code} <strong>(*)</strong>{' '}
                    <span className="help">
                      <i className="fas fa-question-circle" />
                      <div>{this.props.language.account.help.codeVehicle}</div>
                    </span>
                  </label>
                </div>
                <div>
                  <input autoComplete="off" type="text" id="code" className="modal-input" />
                </div>
              </div>
              <ExtendedPropertyCreator
                prefix="create-"
                extendedPropertiesValue={null}
                extendedProperties={this.props.extendedProperties}
              />

              {this.props.filter.length > 0 && (
                <Fragment>
                  <div className="module-title left">
                    <h2>
                      {this.props.language.account.others.categories} <strong>(*)</strong> <p>{this.props.language.account.others.selectOnlyOneItem}</p>
                    </h2>
                  </div>

                  {this.props.filter.map((item, i) => (
                    <ModalItemCategories
                      key={`tags-${i}`}
                      index={i}
                      action="create"
                      category={item}
                      language={this.props.language}
                      config={this.props.config}
                      handleChange={this.handleChangeCategories}
                      handleErrors={this.handleErrorsCategories}
                      isMultiple={false}
                    />
                  ))}
                </Fragment>
              )}

              {this.props.datosDatasource.length > 0 && (
                <div className="module-title left">
                  <h2>{this.props.language.account.createVehicules.dataSource}</h2>
                  <p>{this.props.language.account.createVehicules.dataSourceDescent}</p>
                </div>
              )}
              {this.props.datosDatasource.length > 0 &&
                this.props.datosDatasource.map((item, i) => (
                  <div key={i} className="box-form islabel flex align-center top ">
                    <div className="width100">
                      <label className="modal-label padding-reset">{item.alias}:</label>
                    </div>
                    <div>
                      <input
                        data-hom={`hom-${i}`}
                        data-type={`${item.alias}`}
                        autoComplete="off"
                        type="text"
                        id={`hom-${i}`}
                        className="modal-input"
                      />
                    </div>
                  </div>
                ))}
            </section>
          </div>
        )}
        {this.props.statusSave != 200 && (
          <div className={'box-form islabel top center modal-button-box '}>
            <div>
              {this.props.loadingSave ? (
                <div className="spiner">
                  <i className="fas fa-spinner fa-spin" /> {this.props.language.account.others.loading}
                </div>
              ) : (
                <input
                  className="active"
                  onClick={this.handleSubmit}
                  type="button"
                  value={this.props.language.account.createVehicules.create}
                />
              )}
            </div>
          </div>
        )}
        {this.props.statusSave == 200 && (
          <div className={`box-modal max500`}>
            <section className={this.props.dataSave.homologations ? 'feed-back green' : 'feed-back yellow'}>
              <div>
                <i className="fas fa-check-circle" />
              </div>
              <div>
                <p>
                  {this.props.dataSave.homologations
                    ? this.props.language.account.createVehicules.feedBackOkEdit
                    : this.props.language.account.createVehicules.feedBackWarningEdit}
                </p>
              </div>
            </section>
          </div>
        )}

        {
          (this.state.showErrors) && (
            <SweetAlert
              error
              closeOnClickOutside={true}
              confirmBtnCssClass="confirm-button"
              title={
                <span className="modal-title">
                  <strong>
                    {this.props.language.account.others.formWithErrors}
                  </strong>
                </span>
              }
              onConfirm={() => this.handleShowErrors(false)}
              onCancel={() => this.handleShowErrors(false)}
            >
              <div className="tilte-modal-box">
                {this.props.language.account.others.reviewInformationBeforeSending}
              </div>
            </SweetAlert>
          )
        }
      </div>
    );
  }
};

export default ModalCreate;



// WEBPACK FOOTER //
// ./source/client/components/account_vehicle/modalCreate.jsx